import React from 'react';
import './Home.scss';

function Home({ ...props }) {
  return <div>Welcome home!</div>;
}

export default Home;
